export enum ELanguage {
  ENGLISH = 'en',
  HINDI = 'hi',
  PORTUGUESE = 'pt',
  SPANISH = 'es',
  THAI = 'th',
  ARABIC = 'ar',
  FRENCH = 'fr'
}
